// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"72bc9af6","166":"fd88d8f3","238":"b78b47b9","294":"90e01f86","362":"cc1003b1","385":"d364c1c4","453":"8c3e0d99","477":"e1b81e88","680":"d299deab","769":"31aa20e0","806":"2d9bc634","813":"efb6dc66","823":"2a4d8e24","877":"02e97024"}[chunkId] + ".chunk.js";
};